/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/CancelOrderItems',[
    'jquery',
    'lodash',
    'global/all',
    './CancelOrderItems.Forms'
], function ($, _, Roc, CancelOrderItemsForms) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var orderCancelLists = {};
    var forms = CancelOrderItemsForms;
    var rmSelectedFile;

    var elems = {
        cancelCheckbox: '[data-roc-action="cancelItemCheckbox"]',
        cancelBtn: '[data-roc-action="cancelItems"]'
    };

    function setCanCancelOnItems(order) {
        for (var i = 0; i < order.recipients.length; i++) {
            var recipient = order.recipients[i];
            for (var j = 0; j < recipient.items.length; j++) {
                recipient.items[j].canCancel = true;
            }
        }
    }

    function cancelItemCheckedEvt() {
        $(document)
            .off('change', elems.cancelCheckbox)
            .on('change', elems.cancelCheckbox,
                function () {
                    var isChecked = $(this).is(':checked');
                    var orderId = $(this).data('order-id');
                    var itemId = $(this).data('id');
                    if (!orderCancelLists[orderId]) {
                        orderCancelLists[orderId] = [];
                    }
                    if (isChecked) {
                        if (orderCancelLists[orderId].indexOf(itemId) === -1) {
                            orderCancelLists[orderId].push(itemId);
                        }
                    } else {
                        var itemIndex = orderCancelLists[orderId].indexOf(itemId);
                        if (itemIndex !== -1) {
                            orderCancelLists[orderId].splice(itemIndex, 1);
                        }
                    }
                    if (orderCancelLists[orderId].length > 0) {
                        $('#cancelItems' + orderId).show();
                    } else {
                        $('#cancelItems' + orderId).hide();
                    }
                });
    }

    function cancelItemsBtnPressedEvt() {
        $(document)
            .off('click', elems.cancelBtn)
            .on('click', elems.cancelBtn,
                function () {
                    var orderId = $(this).data('id');
                    getFormDetails(orderId)
                        .then(function (data) {
                            openRMAForm(data, orderId);
                        })
                        .fail(function () {
                            Roc.UI.error("Could not get form details");
                        });

                });
    }

    function bindFileUploadEvt() {
        $(document).on('change', '#rma_upload_picture',
            function (event) {
                rmSelectedFile = event.target.files;
            });
    }

    function openRMAForm(details, orderId) {
        var model = details;
        model.orderId = orderId;

        Roc.UI.template('returnMaterialForm-Tmp', model)
            .then(function (renderedTemplate) {
                Roc.UI.confirm({
                    "title": 'RMA form',
                    "message": renderedTemplate,
                    "buttons": {
                        "Continue": {
                            "class": 'btn btnAction rma-submit',
                            "autoClose": false,
                            "action": function () {
                                if (!Roc.Validation.validateForm(forms.RmaForm)) {
                                    return;
                                }
                                Roc.Core.lockButton('.btn.btnAction.rma-submit');
                                var data = Roc.Forms.getFormValues(forms.RmaForm);
                                data.orderId = orderId;
                                data.items = orderCancelLists[orderId];
                                var uploadFileResult = uploadFile(function (uploadFileResult) {
                                    if (uploadFileResult.success) {
                                        data.uploadedFile = uploadFileResult.fileName;
                                        return;
                                    } else {
                                        Roc.UI.displayErrorPopup(result.error);
                                        return;
                                    }
                                });
                                sendForm(data)
                                    .then(function () {
                                        Roc.UI.success("Form submitted successfully");
                                        $(".rma-close-modal").trigger('click');
                                    })
                                    .fail(function () {
                                        Roc.UI.error("Could not submit the form");
                                    })
                                    .always(function () {
                                        Roc.Core.releaseLockedButton('.btn.btnAction.rma-submit');
                                    });
                            }
                        },
                        "Cancel": {
                            "class": 'btn rma-close-modal',
                            "autoClose": true,
                            "action": function () { }
                        }
                    }
                });
            });
    }

    //API Calls
    function uploadFile(callback) {

        if (!rmSelectedFile) {
            return;
        }

        var data = new FormData();
        $.each(rmSelectedFile, function (key, value) {
            data.append(key, value);
        });

        $.ajax({
            // Your server script to process the upload
            url: apiUrl + '/api/rmaform/upload',
            type: 'POST',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            success: function (data) {
                callback({
                    success: typeof data.error === 'undefined',
                    fileName: data.fileName,
                    error: data.error
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                callback({
                    success: false,
                    error: textStatus + ", " + errorThrown
                });
            }
        });
    }

    function sendForm(data) {
        return $.ajax({
            url: apiUrl + '/api/rmaform/add',
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data)
        });
    }

    function getFormDetails(orderId) {
        return $.ajax({
            url: apiUrl + '/api/rmaform/details/' + orderId,
            type: 'GET',
            contentType: 'application/json'
        });
    }



    function bindEvents() {
        cancelItemCheckedEvt();
        cancelItemsBtnPressedEvt();
        bindFileUploadEvt();
    }

    function init() {
        bindEvents();
    };

    var CancelOrderItems = {
        init: init,
        setCanCancelOnItems: setCanCancelOnItems
    };

    Roc.Logger.debug('CancelOrderItems.js Loaded:', CancelOrderItems);

    return CancelOrderItems;
});
